<script>
import StoreSearchResultsTabList from '@phoenix/mixins/components/store/StoreSearchResultsTabList';

export default {
  mixins: [StoreSearchResultsTabList],
};
</script>

<template>
  <div v-if="hasResults">
    <div v-if="hasBoutiques" class="boutique-cards__grid">
      <store-card
        v-for="store in boutiques"
        :key="store.id"
        :address="store.fullAddress"
        :image="store.rokkaImg"
        :title="store.name"
        :status="store.status"
        :phone="store.phone"
        :permalink="store.permalink"
        :is-online="store.isOnline"
        :see-more-label="store.seeMoreLabel"
        :is-reseller="store.isReseller"
        :is-repairer="store.isRepairer"
        :services="store.services"
      />
    </div>

    <div v-if="hasRetailers" class="boutique-cards__grid">
      <store-card
        v-for="store in retailers"
        :key="store.id"
        :address="store.fullAddress"
        :image="store.rokkaImg"
        :title="store.name"
        :status="store.status"
        :phone="store.phone"
        :permalink="store.permalink"
        :is-online="store.isOnline"
        :see-more-label="store.seeMoreLabel"
        :is-reseller="store.isReseller"
        :is-repairer="store.isRepairer"
        :services="store.services"
      />
    </div>
  </div>

  <div v-else>
    {{ $t('StoreSearch.noResults') }}
  </div>
</template>
